import { GEOMETRY_TYPE } from '@tmapy/config';
import { getFeatureFromLayer } from './index';
import { ADD_LAYERS, SET_MAP_STATE, SET_MAP_ZOOM, ADD_MAP_ZOOM, SET_MAP_ROTATION, SET_MAP_CENTER, SET_LAYER_VISIBILITY, SET_MAP_DEFAULT_STATE, SET_LAYER_STYLE, MAP_MOVE_END, MAP_CLICK, INTERACTION_SELECT_FEATURES, INTERACTION_DRAW_FEATURES, DELETE_FEATURES, DELETE_ALL_FEATURES, INTERACTION_MODIFY_FEATURES, SET_LAYER_OPACITY, SET_LAYER_FEATURE_HIGHLIGHT, SET_LAYER_FEATURES, SET_MAP_EXTENT, SET_INTERACTION, INVALIDATE_VECTOR_TILE_LAYER, SET_VECTOR_TILE_HIDDEN_FEATURES, MERGE_LAYERS, ADD_VECTOR_TILE_HIDDEN_FEATURES, SET_SNAP_INTERACTION, } from './constants';
import { featureToGeoJSONObject } from './utils/featureToGeoJSONObject';
import { isSameHighlight } from './utils/highlight';
export const actionAddLayers = (payload) => ({
    type: ADD_LAYERS,
    payload,
});
export const actionSetLayerStyle = (id, style, highlightStyle) => ({
    type: SET_LAYER_STYLE,
    payload: { id, style, highlightStyle },
});
export const actionMoveEnd = (payload) => ({
    type: MAP_MOVE_END,
    payload,
});
export const actionMapClick = (payload) => ({
    type: MAP_CLICK,
    payload,
});
export const actionInteractionSelectFeatures = (layerId, features) => ({
    type: INTERACTION_SELECT_FEATURES,
    payload: {
        layerId,
        featureIds: features.map((feature) => feature.getId() ?? feature.get('id')),
    },
});
export const actionInteractionDrawFeatures = (layerId, features, kind) => ({
    type: INTERACTION_DRAW_FEATURES,
    payload: {
        layerId,
        features: features.map(featureToGeoJSONObject),
        kind,
    },
});
export const actionDeleteFeatures = (layerId, featureIds) => ({
    type: DELETE_FEATURES,
    payload: {
        layerId,
        featureIds,
    },
});
export const actionDeleteAllFeatures = (layerId) => ({
    type: DELETE_ALL_FEATURES,
    payload: {
        layerId,
    },
});
export const actionInteractionModifyFeatures = (layerId, features) => ({
    type: INTERACTION_MODIFY_FEATURES,
    payload: {
        layerId,
        features: features.map(featureToGeoJSONObject),
    },
});
export const actionInteractionModifyGeoJSONFeatures = (layerId, features) => ({
    type: INTERACTION_MODIFY_FEATURES,
    payload: {
        layerId,
        features,
    },
});
export const actionInvalidateVectorTileLayer = (layerId) => ({
    type: INVALIDATE_VECTOR_TILE_LAYER,
    payload: { layerId },
});
export const actionSetMapDefaultState = () => ({ type: SET_MAP_DEFAULT_STATE, payload: null });
export const actionSetMapState = (state) => ({
    type: SET_MAP_STATE,
    payload: { ...state },
});
export const actionSetZoom = (zoom) => ({
    type: SET_MAP_ZOOM,
    payload: zoom,
});
export const actionSetCenter = (center) => ({
    type: SET_MAP_CENTER,
    payload: center,
});
export const actionSetExtent = (extent, padding, maxZoom) => ({
    type: SET_MAP_EXTENT,
    payload: {
        extent,
        padding,
        maxZoom,
    },
});
export const actionSetRotation = (rotation) => ({
    type: SET_MAP_ROTATION,
    payload: rotation,
});
export const actionAddZoom = (diff) => ({
    type: ADD_MAP_ZOOM,
    payload: diff,
});
export const actionSetLayerVisibility = (payload) => ({
    type: SET_LAYER_VISIBILITY,
    payload,
});
export const actionSetLayerOpacity = (payload) => ({
    type: SET_LAYER_OPACITY,
    payload,
});
export const actionSetLayerFeatures = (layerId, features) => ({
    type: SET_LAYER_FEATURES,
    payload: {
        layerId,
        features: features.map((feature) => ({
            ...feature,
            // duplicita LayerId (nas identifikacni parametr, ktery je vyuzivan cross monorepo)
            // a layer (z duvodu nasazeni ol-mapbox-style, ktery interne pouziva prave tento parametr)
            // -> sjednoceni by bylo dosti problematicke a proto se k tomuto kroku uchylime
            // v pripade potvrzeni technologie pro stylovani
            properties: { ...feature.properties, layerId, layer: layerId },
        })),
    },
});
export const actionSetInteraction = (payload, meta) => ({
    type: SET_INTERACTION,
    payload,
    meta,
});
export const actionSetLayerFeatureHighlight = (payload) => (dispatch, getState) => {
    const state = getState();
    const oldValues = state.mapCore.interaction.highlightedFeatures;
    const types = payload.highlightedFeatures.map((highlightFeature) => {
        const feature = highlightFeature.featureId
            ? getFeatureFromLayer(state.mapCore.layers, highlightFeature.layerId, highlightFeature.featureId)
            : null;
        return feature?.geometry?.type;
    });
    if (types.includes(GEOMETRY_TYPE.LINE_STRING) ||
        types.includes(GEOMETRY_TYPE.MULTI_LINE_STRING) ||
        !isSameHighlight(oldValues, payload.highlightedFeatures)) {
        dispatch({
            type: SET_LAYER_FEATURE_HIGHLIGHT,
            payload,
            meta: { oldValues },
        });
    }
};
export const actionSetVectorTileHiddenFeatures = (layerId, featureIds) => ({
    type: SET_VECTOR_TILE_HIDDEN_FEATURES,
    payload: { layerId, featureIds },
});
export const actionMergeLayers = (payload) => ({
    type: MERGE_LAYERS,
    payload,
});
export const actionAddHiddenFeatures = (layerId, featureIds) => ({
    type: ADD_VECTOR_TILE_HIDDEN_FEATURES,
    payload: { layerId, featureIds },
});
export const actionSetSnapInteraction = (payload) => ({
    type: SET_SNAP_INTERACTION,
    payload,
});
//# sourceMappingURL=actions.js.map